import Trigger from 'eflex/models/trigger';

export default class AdamIoTrigger extends Trigger {}
